import { createSlice } from '@reduxjs/toolkit';
import { ILocalization } from '../../../core/interfaces/ILocalization';
import { CountriesType } from '../../../core/components/language-selector/CountriesType';
import { LanguagesTypes } from '../../../core/components/language-selector/LanguagesTypes';
import { LocalizationReducer } from '../../reducers/LoacalizationReducer';

const initialState: ILocalization = {
	country: CountriesType.BR,
	language: LanguagesTypes.PT,
};

export const localizationSlice = createSlice({
	name: 'localization',
	initialState,
	reducers: LocalizationReducer,
});

export const {
	setLanguage,
	setCountry,
	setLocalization,
	setIsLoadingLanguage,
} = localizationSlice.actions;

export default localizationSlice.reducer;
